module.exports = __webpack_public_path__ + "img/logo-computa-white.f0c11ec2.svg";